export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
}

export const GIA_API_KEYS = {
  en: '232a07af-4bc0-4592-adeb-d5e80e38297a',
  es: '53599d5c-cee6-4ae4-a21f-07d2f372e730',
}
